<template>
  <div class="filtering-menu" :class="{ 'filtering-menu--open': isOpen }">
    <button
      class="filtering-menu__button-toggle"
      type="menu"
      @click.prevent="toggleOverlay"
    >
      <slot name="button-open-content">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" v-bind:svg-inline="''" v-bind:class="'filtering-menu__icon'" v-bind:role="'img'" v-bind:aria-label="'Menu'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#000" d="M24.1 14.8h0H5.3a.3.3 0 010-.7h18.8a.3.3 0 010 .7m0 5h0H5.3a.3.3 0 010-.7h18.8a.3.3 0 010 .7m0-10.1h0H5.3a.3.3 0 010-.7h18.8a.3.3 0 010 .7" fill-rule="evenodd" stroke="#fff"/></svg>
      </slot>
    </button>
    <div @click.prevent="toggleOverlay" class="filtering-menu__shadow"></div>
    <div
      class="filtering-menu__container"
      :class="{
        'overflow-hidden-sm': isChildOpen,
        'filtering-menu__container--no-scroll': childOpen !== null,
      }"
      ref="filteringMenuContainer"
    >
      <div class="filtering-menu__top-container">
        <button
          @click.prevent="toggleOverlay"
          class="filtering-menu__button-menu"
        >
          <p class="filtering-menu__top-text">Filtrér</p>
          <div class="icon--plus icon--rotate" />
        </button>
      </div>
      <div class="filtering-menu__content-container overlay--filtering">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/main'

import { toggleDocumentOverflow } from '@/functions'

export default {
  data() {
    return {
      isOpen: false,
      scrollYPosition: 0,
      childOpen: null,
    }
  },
  props: {
    name: { default: null, type: String },
    isChildOpen: { default: false, type: Boolean },
    eventBus: { default: null, type: Object },
  },
  watch: {
    isOpen(newValue) {
      toggleDocumentOverflow(newValue, 'overflow-hidden')
    },
  },
  methods: {
    toggleOverlay() {
      if (this.isOpen) {
        this.closeOverlay()
      } else {
        this.openOverlay()
      }
    },
    openOverlay() {
      if (this.isOpen) return

      this.isOpen = true

      const owner = this

      app.history.push(() => {
        owner.isOpen = false
      }, 'pop-all-immune')
    },
    closeOverlay() {
      if (!this.isOpen) return

      app.history.pop()
    },
    handleKeyUp(event) {
      if (!this.isOpen) return
      if (event.keyCode !== 27) return

      this.toggleOverlay()
    },
    handleOverlayChildOpening(childELement) {
      this.childOpen = childELement

      this.scrollYPosition = this.$refs.filteringMenuContainer.scrollTop
      setTimeout(() => {
        this.$refs.filteringMenuContainer.scrollTo(0, 0)
      }, 50)
    },
    handleOverlayChildClosing(childELement) {
      if (this.childOpen == null) return
      if (this.childOpen !== childELement) return

      setTimeout(() => {
        this.childOpen = null
        if (this.scrollYPosition === 0) return

        this.$refs.filteringMenuContainer.scrollTo({
          top: this.scrollYPosition,
          behavior: 'auto',
        })
        this.scrollYPosition = 0
      }, 50)
    },
    handleCloseAllChildren() {
      setTimeout(() => {
        this.childOpen = null
        this.$refs.filteringMenuContainer.scrollTo({
          top: this.scrollYPosition,
          behavior: 'auto',
        })
        this.scrollYPosition = 0
      }, 50)
    },
  },
  created() {
    window.addEventListener('keyup', this.handleKeyUp)
    this.eventBus.on('overlay-toggle', this.handleOverlayChildOpening)
    this.eventBus.on('overlay-close', this.handleOverlayChildClosing)
    this.eventBus.on('child-close', this.handleOverlayChildClosing)
    this.eventBus.on('overlay-close-all', this.handleCloseAllChildren)
  },
}
</script>

<style lang="scss">
@import 'FilteringMenu.scss';
</style>
